<template>
  <div class="container">
    <div class="table-header">
      <h1>Rates</h1>
    </div>

    <RatesTable></RatesTable>
  </div>
</template>

<script setup lang="ts">
import RatesTable from './Rates-table.vue'
</script>
